import { ReactComponent as airplaneIcon } from "../../assets/svgs/icon_airplane.svg";
import { ReactComponent as cardIcon } from "../../assets/svgs/icon_cc4.svg";
import { ReactComponent as earthIcon } from "../../assets/svgs/icon_earth.svg";
import { ReactComponent as foodIcon } from "../../assets/svgs/icon_food.svg";
import { ReactComponent as reloadIcon } from "../../assets/svgs/icon_reload.svg";
import { ReactComponent as seedsIcon } from "../../assets/svgs/icon_seeds.svg";
import { ReactComponent as seedsGiveIcon } from "../../assets/svgs/icon_seedsGive.svg";
import { ReactComponent as shoppingIcon } from "../../assets/svgs/icon_shopping.svg";
import { ReactComponent as shopSustainableIcon } from "../../assets/svgs/icon_shopSustainable.svg";
import { ReactComponent as starIcon } from "../../assets/svgs/icon_star.svg";

export const ICONS = {
  airplane: airplaneIcon,
  card: cardIcon,
  earth: earthIcon,
  food: foodIcon,
  reload: reloadIcon,
  seeds: seedsIcon,
  seedsGive: seedsGiveIcon,
  shopping: shoppingIcon,
  shopSustainable: shopSustainableIcon,
  star: starIcon
};

export const AVAILABLE_ICONS = Object.keys(ICONS);
